"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { toSnakeCase } from 'js-convert-case';
import useDataBuilder from '../../DataBuilder/use-data-builder.mjs';
import useDataBuilderField from '../../DataBuilder/use-data-builder-field.mjs';
import { DropdownUI } from '../../DropdownUI/index.mjs';
import { useComboBox } from '../context/use-combobox.mjs';
import { useComboBoxDropdownContext } from '../context/use-combobox-dropdown.mjs';
import { useKeyboardBinding } from './KeyboardNavigation/useKeyboardBinding.mjs';
import { VirtualizedDropdownList } from './VirtualizedDropdownList.mjs';

function OptionsList({ onOptionSelect }) {
  const { onAddVariable } = useDataBuilder();
  const { field } = useDataBuilderField();
  const { isOptionSelected, canUseParentInputSearchValue, drillDown, optionsPayload, drillUp } = useComboBoxDropdownContext();
  const { value: parentInputValue } = useComboBox();
  const [result, optionsError, optionsState] = optionsPayload;
  const { options = [], fallbackOptions = [] } = result || {};
  useKeyboardBinding({ options, fallbackOptions, onEnter: handleOptionSelect });
  function handleOptionSelect(option) {
    if (option === "drill-up") {
      drillUp();
      return;
    }
    if (option.addVariable) {
      const objectLocator = option.addVariable;
      const variableLocator = `${objectLocator}.${field.key || toSnakeCase(field.name) || toSnakeCase(field?.schema?.title)}`;
      onAddVariable?.(variableLocator, field.schema ?? {});
      onOptionSelect({
        $var: variableLocator
      });
    } else if (option.drillDownOptionFactory || option.childCategory && !option.value) {
      drillDown(option);
    } else {
      onOptionSelect(option.value);
    }
  }
  return /* @__PURE__ */ jsx(DropdownListState, { state: optionsState, error: optionsError, children: /* @__PURE__ */ jsx(
    VirtualizedDropdownList,
    {
      searchTerm: canUseParentInputSearchValue ? parentInputValue : void 0,
      options,
      fallbackOptions,
      isOptionSelected,
      handleOptionSelect
    }
  ) });
}
function DropdownListState({
  state,
  error,
  children
}) {
  if (state === "rejected" || error) {
    return /* @__PURE__ */ jsx(DropdownUI.ErrorHeading, { text: error?.message || "Something went wrong" });
  }
  if (state === "pending") {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(DropdownUI.LoadingItem, {}),
      /* @__PURE__ */ jsx(DropdownUI.LoadingItem, {}),
      /* @__PURE__ */ jsx(DropdownUI.LoadingItem, {})
    ] });
  }
  return children;
}

export { OptionsList };
